{
  "familyId": "REK-SCHATTEN",
  "questions": [
    {
      "id": "REK-SCHATTEN-001",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je rekent 78 × 4. Welk antwoord kan NIET kloppen?",
      "options": ["3.120", "312", "292", "320"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 200,
            "end": 400,
            "step": 20,
            "highlight": [320],
            "marked": [292, 312, 320],
            "label": "Schatting: 80 × 4 = 320 — het antwoord ligt hier in de buurt"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten om te controleren",
            "content": "Schat eerst het antwoord vóór je rekent. 78 ≈ 80, dus 80 × 4 = 320. Het antwoord moet in de buurt van 320 liggen. 3.120 is bijna 10× te veel — dat kan niet kloppen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_controle",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Schat eerst het antwoord vóór je rekent. 78 ≈ 80, dus 80 × 4 = 320. Het antwoord moet in de buurt van 320 liggen. 3.120 is bijna 10× te veel — dat kan niet kloppen. Het echte antwoord is 312.",
        "solutionSteps": [
          "Rond af: 78 ≈ 80",
          "Reken: 80 × 4 = 320",
          "Het antwoord moet rond de 320 liggen",
          "3.120 is bijna 10× te groot — dat kan niet kloppen",
          "Check: het echte antwoord is 78 × 4 = 312 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3.120 is veel te groot. De schatting 80 × 4 = 320, dus het antwoord moet rond de 300 liggen, niet rond de 3.000.",
          "1": "Je dacht waarschijnlijk dat 312 niet klopt. Maar 312 is precies het juiste antwoord van 78 × 4. Onthoud: schat eerst met een rond getal (80 × 4 = 320) en kijk welk antwoord ver weg ligt.",
          "2": "Je dacht waarschijnlijk dat 292 te ver weg ligt. Maar het verschil met het echte antwoord (312) is maar 20 — dat is dichtbij genoeg. Onthoud: bij schatten zoek je de uitbijter, niet een klein verschil.",
          "3": "Je dacht waarschijnlijk dat 320 niet klopt. Maar 320 is precies de schatting (80 × 4 = 320) en ligt heel dicht bij het echte antwoord (312). Onthoud: de schatting zelf kan ook een antwoord zijn."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-exact-als-fout", "label": "Denkt dat het exacte antwoord niet kan kloppen", "optionIndex": 1 },
          { "id": "rek.schatten-klein-verschil-is-fout", "label": "Denkt dat een klein verschil met de schatting fout is", "optionIndex": 2 },
          { "id": "rek.schatten-schatting-is-fout", "label": "Denkt dat de schatting zelf niet kan kloppen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-002",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een leraar geeft een rekentoets. Bij de som 49 + 52 schrijft een leerling als antwoord 91. De leraar zegt: \"Schat eerst om te controleren.\" Welke schatting laat zien dat 91 niet kan kloppen?",
      "options": [
        "40 + 50 = 90 — het antwoord moet rond de 90 liggen, dus 91 klopt wel",
        "49 + 50 = 99 — het antwoord is precies 99",
        "50 + 50 = 100 — het antwoord moet rond de 100 liggen, niet 91",
        "50 + 60 = 110 — het antwoord moet rond de 110 liggen"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten om te controleren",
            "content": "Rond beide getallen af naar het dichtstbijzijnde tiental. 49 ≈ 50 en 52 ≈ 50. Dan reken je 50 + 50 = 100. Het echte antwoord moet rond de 100 liggen. 91 is te laag — de leerling heeft een fout gemaakt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_afronden_beide",
      "variantIndex": 2,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Rond beide getallen af: 49 ≈ 50 en 52 ≈ 50. Schatting: 50 + 50 = 100. Het echte antwoord is 101. De leerling schreef 91 — dat is bijna 10 te laag. De schatting laat zien dat er een fout zit in het antwoord van de leerling.",
        "solutionSteps": [
          "Rond af: 49 ≈ 50 en 52 ≈ 50",
          "Schatting: 50 + 50 = 100",
          "De leerling schreef 91 — dat is ~10 te laag",
          "Conclusie: 91 kan niet kloppen, het antwoord moet rond de 100 liggen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 49 dichter bij 40 ligt. Maar 49 is slechts 1 verwijderd van 50 en 9 verwijderd van 40. De schatting 40 + 50 = 90 is onnauwkeurig en zou de fout (91) juist bevestigen. Onthoud: rond af naar het dichtstbijzijnde tiental voor de beste schatting.",
          "1": "Je dacht waarschijnlijk dat je maar één getal hoeft af te ronden. Maar 49 + 50 = 99 is geen schatting — je rekent dan bijna exact. Het doel van schatten is snel controleren met makkelijke getallen. Onthoud: rond beide getallen af.",
          "2": "Goed! 50 + 50 = 100 is de beste schatting. Het echte antwoord (101) ligt dicht bij 100, maar 91 is te ver weg — de leerling heeft een fout gemaakt.",
          "3": "Je dacht waarschijnlijk dat 52 dichter bij 60 ligt. Maar 52 is slechts 2 verwijderd van 50 en 8 verwijderd van 60. De schatting 50 + 60 = 110 is te hoog. Onthoud: rond af naar het dichtstbijzijnde tiental."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar een te ver verwijderd tiental", "optionIndex": 0 },
          { "id": "rek.schatten-maar-een-getal", "label": "Rondt maar één getal af", "optionIndex": 1 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar een te ver verwijderd tiental", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-003",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je koopt 3 skins in een game die elk €8,95 kosten. Hoeveel betaal je ongeveer?",
      "options": ["ongeveer €24", "ongeveer €27", "ongeveer €30", "ongeveer €9"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden en dan rekenen",
            "content": "Rond het bedrag af naar een handig getal. €8,95 ≈ €9. Dan reken je: 3 × €9 = €27. Het echte antwoord is €26,85 — de schatting is heel goed!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_context_geld",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Rond het bedrag af naar een handig getal. €8,95 ≈ €9 (bijna 9 euro). Dan reken je: 3 × €9 = €27. Het echte antwoord is 3 × €8,95 = €26,85, dus de schatting van €27 is heel goed!",
        "solutionSteps": [
          "Rond af: €8,95 ≈ €9",
          "Reken: 3 × €9 = €27",
          "Check: het echte antwoord is 3 × €8,95 = €26,85 — dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 3 × €9 = €27. Door €8,95 af te ronden naar €9 krijg je een snelle en nauwkeurige schatting.",
          "1": "Je dacht waarschijnlijk dat €8,95 dichter bij €8 ligt. Maar €8,95 is slechts 5 cent verwijderd van €9 en 95 cent verwijderd van €8. Onthoud: rond af naar het dichtstbijzijnde hele getal.",
          "2": "Je dacht waarschijnlijk dat €8,95 dichter bij €10 ligt. Maar €8,95 is slechts 5 cent verwijderd van €9 en €1,05 verwijderd van €10. Onthoud: rond af naar het dichtstbijzijnde hele getal, niet naar het volgende tiental.",
          "3": "Je dacht waarschijnlijk dat je maar 1 skin hoeft te berekenen. Maar je koopt 3 skins, dus je moet vermenigvuldigen: 3 × €9 = €27. Onthoud: lees goed hoeveel stuks er gevraagd worden."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-verkeerde-richting", "label": "Rondt af naar beneden i.p.v. dichtstbijzijnde", "optionIndex": 0 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar het volgende tiental i.p.v. eenheid", "optionIndex": 2 },
          { "id": "rek.schatten-vergeet-vermenigvuldigen", "label": "Vergeet te vermenigvuldigen met het aantal", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-004",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een YouTuber heeft 198.000 views en wil deze verdelen over 4 video's. Hoeveel views heeft elke video ongeveer?",
      "options": ["ongeveer 40.000", "ongeveer 200.000", "ongeveer 500.000", "ongeveer 50.000"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden naar een deelbaar getal",
            "content": "Rond af naar een getal dat makkelijk deelbaar is. 198.000 ≈ 200.000, en 200 is makkelijk deelbaar door 4. 200.000 ÷ 4 = 50.000. Het echte antwoord is 49.500 — de schatting klopt!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_deling",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Rond af naar een getal dat makkelijk deelbaar is. 198.000 ≈ 200.000, en 200 is makkelijk deelbaar door 4. 200.000 ÷ 4 = 50.000. Het echte antwoord is 49.500, dus de schatting van 50.000 is uitstekend!",
        "solutionSteps": [
          "Rond af: 198.000 ≈ 200.000 (dichtbij en deelbaar door 4)",
          "Reken: 200.000 ÷ 4 = 50.000",
          "Check: het echte antwoord is 198.000 ÷ 4 = 49.500 — heel dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 198 dichter bij 160 ligt (want 4 × 40 = 160). Maar 198 is veel groter dan 160. Onthoud: rond af naar het dichtstbijzijnde getal dat makkelijk deelbaar is — hier is dat 200.",
          "1": "Je dacht waarschijnlijk dat 200.000 het antwoord is. Maar 200.000 is het getal dat je deelt, niet het resultaat. 198.000 ÷ 4 ≈ 200.000 ÷ 4 = 50.000. Onthoud: het antwoord van een deling is altijd kleiner dan het oorspronkelijke getal.",
          "2": "Je dacht waarschijnlijk dat je moet vermenigvuldigen in plaats van delen. Maar 4 × 50.000 = 200.000. De YouTuber verdeelt 198.000 views, dus je deelt: 198.000 ÷ 4 ≈ 50.000. Onthoud: verdelen = delen.",
          "3": "Goed! 200.000 ÷ 4 = 50.000. Door 198.000 af te ronden naar 200.000 wordt de deling makkelijk."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar een te ver verwijderd getal", "optionIndex": 0 },
          { "id": "rek.schatten-deeltal-als-antwoord", "label": "Geeft het deeltal als antwoord i.p.v. het quotiënt", "optionIndex": 1 },
          { "id": "rek.schatten-keer-ipv-delen", "label": "Vermenigvuldigt i.p.v. te delen", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-005",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je controleert je rekensom op school: 623 − 187. Welke schatting helpt om snel te checken of je antwoord ongeveer klopt?",
      "options": [
        "600 − 200 = 400",
        "600 − 100 = 500",
        "700 − 200 = 500",
        "620 − 190 = 430"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Rond beide getallen af op honderdtallen voor een snelle controle. 623 ≈ 600 en 187 ≈ 200. Dan reken je: 600 − 200 = 400. Het echte antwoord is 436 — dichtbij!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_controle_aftrekking",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond beide getallen af op honderdtallen voor een snelle controle. 623 ≈ 600 en 187 ≈ 200. Dan reken je: 600 − 200 = 400. Het echte antwoord is 436, dus als je iets rond de 400 uitkomt, klopt het waarschijnlijk.",
        "solutionSteps": [
          "Rond af: 623 ≈ 600",
          "Rond af: 187 ≈ 200",
          "Reken: 600 − 200 = 400",
          "Check: het echte antwoord is 623 − 187 = 436 — dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 600 − 200 = 400 is de handigste schatting. Beide getallen zijn afgerond op honderdtallen.",
          "1": "Je dacht waarschijnlijk dat 187 dichter bij 100 ligt. Maar 187 is slechts 13 verwijderd van 200 en 87 verwijderd van 100. Onthoud: rond af naar het dichtstbijzijnde honderdtal — het tientallencijfer 8 ≥ 5, dus omhoog naar 200.",
          "2": "Je dacht waarschijnlijk dat 623 dichter bij 700 ligt. Maar 623 is slechts 23 verwijderd van 600 en 77 verwijderd van 700. Onthoud: rond af naar het dichtstbijzijnde honderdtal.",
          "3": "Je dacht waarschijnlijk dat je zo nauwkeurig mogelijk moet afronden. Maar 620 − 190 = 430 is moeilijker uit het hoofd te rekenen dan 600 − 200 = 400. Onthoud: bij schatten kies je de makkelijkste getallen, niet de nauwkeurigste."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-verkeerde-richting", "label": "Rondt 187 af naar 100 i.p.v. 200", "optionIndex": 1 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt 623 af naar 700 i.p.v. 600", "optionIndex": 2 },
          { "id": "rek.schatten-te-nauwkeurig", "label": "Rondt te nauwkeurig af (niet handig genoeg)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-006",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een gamer wil een nieuwe console kopen van €289 en een extra controller van €68. Welke schatting helpt om te weten hoeveel hij ongeveer moet sparen?",
      "options": [
        "300 + 70 = 370",
        "200 + 60 = 260",
        "300 + 100 = 400",
        "280 + 60 = 340"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden naar handige tientallen of honderdtallen",
            "content": "Rond €289 af naar €300 en €68 naar €70. Dan reken je: 300 + 70 = 370. Het echte antwoord is 357 — de schatting is heel goed!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_controle_optelling",
      "variantIndex": 6,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Rond €289 af naar €300 en €68 naar €70. Dan reken je: 300 + 70 = 370. Het echte antwoord is 357, dus als de gamer ongeveer €370 spaart, heeft hij zeker genoeg.",
        "solutionSteps": [
          "Rond af: 289 ≈ 300",
          "Rond af: 68 ≈ 70",
          "Reken: 300 + 70 = 370",
          "Check: het echte antwoord is 289 + 68 = 357 — dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 300 + 70 = 370 is de handigste en beste schatting.",
          "1": "Je hebt beide getallen naar beneden afgerond. Maar 289 ligt veel dichter bij 300 dan bij 200, en 68 ligt dichter bij 70 dan bij 60. Onthoud: rond af naar het dichtstbijzijnde handige getal.",
          "2": "Je hebt 68 afgerond naar 100. Dat is te ver weg, want 68 ligt veel dichter bij 70. Onthoud: je hoeft niet alles op honderdtallen af te ronden als tientallen handiger zijn.",
          "3": "Je hebt 289 afgerond naar 280 en 68 naar 60. Beide zijn naar beneden afgerond, terwijl ze dichter bij 290 (of 300) en 70 liggen. Onthoud: rond af naar het dichtstbijzijnde getal."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-verkeerde-richting", "label": "Rondt af naar beneden i.p.v. dichtstbijzijnde", "optionIndex": 1 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt 68 af naar 100 i.p.v. 70", "optionIndex": 2 },
          { "id": "rek.schatten-afronden-verkeerde-richting", "label": "Rondt af naar beneden i.p.v. dichtstbijzijnde", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-007",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een school heeft 412 leerlingen. Voor een sportdag worden ze verdeeld in teams van ongeveer 8 leerlingen. Hoeveel teams zijn er ongeveer?",
      "options": ["ongeveer 50", "ongeveer 40", "ongeveer 60", "ongeveer 500"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden naar een deelbaar getal",
            "content": "Rond 412 af naar een getal dat makkelijk deelbaar is door 8. 400 is makkelijk deelbaar door 8, want 40 ÷ 8 = 5. Dus 400 ÷ 8 = 50. Er zijn ongeveer 50 teams.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_deling_context",
      "variantIndex": 7,
      "citoDifficulty": 0.39,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "Rond 412 af naar een getal dat makkelijk deelbaar is door 8. 400 is heel handig, want 40 ÷ 8 = 5. Dus 400 ÷ 8 = 50. Er zijn ongeveer 50 teams. Het exacte antwoord is 51,5, dus 50 is een hele goede schatting!",
        "solutionSteps": [
          "Rond af: 412 ≈ 400 (want 40 is deelbaar door 8)",
          "Reken: 400 ÷ 8 = 50",
          "Check: het echte antwoord is 412 ÷ 8 = 51,5 — heel dichtbij ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 400 ÷ 8 = 50. Door 412 af te ronden naar 400 wordt de deling makkelijk.",
          "1": "Je dacht waarschijnlijk aan 320 ÷ 8 = 40. Maar 412 ligt veel dichter bij 400 dan bij 320. Onthoud: rond af naar het dichtstbijzijnde getal dat makkelijk deelbaar is.",
          "2": "Je dacht waarschijnlijk aan 480 ÷ 8 = 60. Maar 412 ligt veel dichter bij 400 dan bij 480. Onthoud: rond af naar het dichtstbijzijnde getal dat makkelijk deelbaar is.",
          "3": "Je dacht waarschijnlijk dat je 412 moest afronden naar 500. Maar je moet het aantal leerlingen verdelen (delen) door 8. 400 ÷ 8 = 50, niet 500."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar een te ver verwijderd getal", "optionIndex": 1 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Rondt af naar een te ver verwijderd getal", "optionIndex": 2 },
          { "id": "rek.schatten-deeltal-als-antwoord", "label": "Geeft het afgeronde deeltal als antwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-008",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Een pretpark verkoopt 1.895 kaartjes op zaterdag en 2.105 kaartjes op zondag. Hoeveel kaartjes zijn dat in het weekend ongeveer samen?",
      "options": ["ongeveer 4.000", "ongeveer 3.000", "ongeveer 5.000", "ongeveer 2.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op duizendtallen",
            "content": "Rond beide getallen af op duizendtallen voor een snelle schatting. 1.895 ≈ 2.000 en 2.105 ≈ 2.000. Dan reken je: 2.000 + 2.000 = 4.000. Het echte antwoord is precies 4.000!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "schatstrategie_optelling_duizendtallen",
      "variantIndex": 8,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "Rond beide getallen af op duizendtallen. 1.895 ligt heel dicht bij 2.000. 2.105 ligt ook heel dicht bij 2.000. Dan reken je: 2.000 + 2.000 = 4.000. Het echte antwoord is toevallig precies 4.000!",
        "solutionSteps": [
          "Rond af: 1.895 ≈ 2.000",
          "Rond af: 2.105 ≈ 2.000",
          "Reken: 2.000 + 2.000 = 4.000",
          "Check: het echte antwoord is 1.895 + 2.105 = 4.000 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 2.000 + 2.000 = 4.000 is de beste schatting.",
          "1": "Je hebt waarschijnlijk 1.895 afgerond naar 1.000. Maar 1.895 ligt veel dichter bij 2.000. Onthoud: rond af naar het dichtstbijzijnde duizendtal.",
          "2": "Je hebt waarschijnlijk beide getallen naar boven afgerond en te groot geschat. 1.895 ≈ 2.000 en 2.105 ≈ 2.000. Samen is dat 4.000, niet 5.000.",
          "3": "Je hebt waarschijnlijk maar één dag geteld. Maar de vraag is hoeveel kaartjes er in het hele weekend (zaterdag én zondag) zijn verkocht. 2.000 + 2.000 = 4.000."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.schatten-afronden-verkeerde-richting", "label": "Rondt 1.895 af naar 1.000 i.p.v. 2.000", "optionIndex": 1 },
          { "id": "rek.schatten-afronden-te-ver", "label": "Schat te hoog in", "optionIndex": 2 },
          { "id": "rek.schatten-vergeet-optellen", "label": "Vergeet de tweede dag op te tellen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-009",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "estimation_slider",
      "question": "Schat de uitkomst van 48 × 7. Waar hoort het antwoord op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 500,
        "correctValue": 336,
        "tolerancePercent": 15,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_keer",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond 48 af naar 50. Reken 50 × 7 = 350. Het antwoord ligt in de buurt van 350. Het exacte antwoord is 336.",
        "solutionSteps": [
          "Rond af: 48 ≈ 50",
          "Reken: 50 × 7 = 350",
          "Plaats de schuif in de buurt van 350"
        ]
      }
    },
    {
      "id": "REK-SCHATTEN-010",
      "familyId": "REK-SCHATTEN",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "schatten",
      "subSkill": "schatstrategie",
      "questionType": "estimation_slider",
      "question": "Schat de uitkomst van 812 ÷ 4. Waar hoort het antwoord op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 300,
        "correctValue": 203,
        "tolerancePercent": 15,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_deel",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond 812 af naar 800. Reken 800 ÷ 4 = 200. Het antwoord ligt in de buurt van 200. Het exacte antwoord is 203.",
        "solutionSteps": [
          "Rond af: 812 ≈ 800",
          "Reken: 800 ÷ 4 = 200",
          "Plaats de schuif in de buurt van 200"
        ]
      }
    }
  ]
}